import { gql } from '@apollo/client';
import upperFirst from 'lodash.upperfirst';
import camelCase from 'lodash.camelcase';
import { getQueryParams } from '../../../../utils';

const buildAdminSearchQuery = (schemas, params, addType = false, indexName = 'admin') => {
  const finalParams = params && !addType ? params : getParamsFromSchema(schemas, params);
  const formattedIndexName = upperFirst(camelCase(indexName));
  return gql`
    query doSearch($where: String!, $offset: Int, $limit: Int, $sort: String) {
      searchResults: search${formattedIndexName}(rawQueryStringified: $where, offset: $offset, limit: $limit, sort: $sort) {
        ${finalParams}
      }
    }
  `;
};

function getParamsFromSchema(schemas, params) {
  const schemaParams = schemas.map(schema => getDisplayPropertiesForSchema(schema, params));
  return `
    results {
      ${schemaParams}
    }
    total
  `;
}

function getDisplayPropertiesForSchema({ id, displayProperties }, passedParams) {
  const typeName = upperFirst(camelCase(id)); // todo: add to schema or create helper function
  const params = passedParams || getQueryParams(displayProperties);
  return `
    ...on ${typeName} {
      ${params}
    }
    __typename
  `;
}

export default buildAdminSearchQuery;
